import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-x-helper';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        paddingBottom: 66,
        marginBottom: -getBottomSpace(),
        paddingTop: 24,
        backgroundColor: props.colors.white,
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
      },
      buttonsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
      },
      unreadMessageMarker: {
        height: 6,
        width: 6,
        borderRadius: 3,
        backgroundColor: props.colors.purple(1),
        position: 'absolute',
        right: 5,
        top: 6,
      },
      bottomButtonContainerStyle: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        marginTop: 15,
      },
      muteAllContainer: {
        height: 46,
        width: 108,
        borderRadius: 8,
        backgroundColor: props.colors.purple(0.13),
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      },
      muteAllImage: {
        width: 24,
        height: 24,
        marginRight: 2,
      },
      muteAllText: {
        fontSize: 17,
        ...props.typography.interMedium,
        color: props.colors.purple(1),
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        container: {
          width: 650,
          height: 88,
          borderRadius: 20,
          marginBottom: 12,
          alignSelf: 'center',
          ...(Platform.OS === 'web'
            ? {
                boxShadow: `0px 0px 10px ${props.colors.shadowGrey}`,
              }
            : {}),
        },
        bottomButtonContainerStyle: {
          flexDirection: 'row',
          justifyContent: 'space-around',
          alignItems: 'center',
          marginTop: 0,
        },
        muteAllContainer: {
          width: 100,
          height: 48,
          marginLeft: 0,
          marginTop: 0,
          marginRight: 15,
        },
        muteAllImage: {
          width: 23,
          height: 23,
        },
      },
    },
  )();
